<template>

  <div class="row" ref="sessionForm">

    <div class="col-xs-12 col-md-12 col-sm-12">
      <ValidationObserver v-slot="{ handleSubmit }" ref="formValidator">
        <div class="col-12">
          <div class="card card-wizard" id="wizardCard">
            <form-wizard shape="tab"
                         :title="formTitle"
                         :subtitle="''"
                         error-color="#FB404B"
                         color="#35495E"
                         ref="itemWizard">
              <tab-content title="English Content"
                           class="col-12"
                           icon="nc-icon nc-notes"
                           :before-change="() => validateStep('englishStep')">
                <english-step :formData="formData ? formData['en'] : defaultFormData['en']"
                              :editMode="editMode"
                              :builderData="builderData"
                              :currentForumId="currentForumId"
                              ref="englishStep"
                              :key="stepKey"
                              @on-validated="onStepValidated" @submit-step="submitStep"></english-step>
              </tab-content>
              <tab-content v-for="(lang, index) in languageList" :key="index" :title="lang.label+' Content'"
                           class="col-12"
                           icon="nc-icon nc-notes"
                           :before-change="() => validateStep(lang.value)">
                <other-languages-step
                  :formData="formData ? formData[lang.value] : defaultFormData[lang.value]"
                  :editMode="editMode"
                  :isSubmit="languageList.length - 1 === index"
                  :lang="lang" :ref="lang.value" @on-validated="onStepValidated"
                  @submit-step="submitStep"></other-languages-step>
              </tab-content>

              <button slot="prev" class="btn btn-default btn-fill btn-wd btn-back">Back</button>
              <button slot="next" class="btn btn-default btn-fill btn-wd btn-next">Next</button>
              <button slot="finish" class="btn btn-success btn-fill btn-wd" :disabled="entityNotFoundError || submitting">Finish</button>
            </form-wizard>
          </div>
        </div>
      </ValidationObserver>

    </div>

  </div>
</template>
<script>
import {extend} from "vee-validate";
import {mapGetters} from "vuex";
import {FormWizard, TabContent} from 'vue-form-wizard'
import 'vue-form-wizard/dist/vue-form-wizard.min.css'
import EnglishStep from "./Wizard/EnglishStep";
import OtherLanguagesStep from "./Wizard/OtherLanguagesStep";


extend("required", {
  message: "{_field_} is required"
});

export default {

  components: {
    FormWizard,
    TabContent,
    OtherLanguagesStep,
    EnglishStep,
  },

  data() {
    return {
      editMode: false,
      loader: {},
      id: undefined,

      formTitle: "",
      entityNotFoundError: false,
      submitting: false,
      formData: {},
      defaultFormData: {
        title: "",
        date: "",
        from_time: "",
        to_time: "",
        content: "",
        image: "",
        is_active: true,
        speakers: [],
        forum_id: '',
        moderators: [],
        panelists:[],
        presenters:[],
        presentersModerators:[],
        ceremony_masters:[],
        sharing_experiences:[],
        experts:[],
        welcome_remarks: [],
        opening_remarks: [],
        keynote_speeches: [],

      },
      builderData: {
        speakersList: [],
        forumList: [],
      },
      wizardModel: {},
      stepKey: 0,
      currentForumId: '',

    };
  },
  computed: {
    ...mapGetters({
      languageList: "global/languageList"
    })
  },
  mounted() {
    this.loader = this.$loading.show({
      container: this.$refs.sessionForm
    });
    this.setNullFormData();

    let data = {}
    this.axios.post("sessions/builder", data).then((response) => {
      this.builderData.speakersList = response.data.speakers;
      this.builderData.forumList = response.data.forums;

      this.id = this.$route.params['id'];

      if (this.id !== undefined) {
        this.editMode = true;
        this.formTitle = "Edit Session";
        this.getSession();
      } else {
        if (response.data.currentForum){
          this.currentForumId = response.data.currentForum.id;
          this.stepKey++;
        }
        this.editMode = false;
        this.formTitle = "Add Session";
        this.loader.hide();
      }
    }).catch((error) => {
      console.error(error);
    })
  },
  methods: {
    getSession() {
      let data = {
        'id': this.id,
      };
      this.axios.post("sessions/get", data).then((response) => {
        this.formData = response.data;
        this.formData['en'].speakers = response.data['en'].speakers.map(speaker => speaker.id);
        this.formData['en'].moderators = response.data['en'].moderators.map(moderator => moderator.id);
        this.formData['en'].panelists = response.data['en'].panelists.map(panelist => panelist.id);
        this.formData['en'].presenters = response.data['en'].presenters.map(presenter => presenter.id);
        this.formData['en'].presentersModerators = response.data['en'].presentersModerators.map(presentersModerators => presentersModerators.id);
        this.formData['en'].ceremony_masters = response.data['en'].ceremony_masters.map(master => master.id);
        this.formData['en'].sharing_experiences = response.data['en'].sharing_experiences.map(experience => experience.id);
        this.formData['en'].welcome_remarks = response.data['en'].welcome_remarks.map(item => item.id);
        this.formData['en'].opening_remarks = response.data['en'].opening_remarks.map(item => item.id);
        this.formData['en'].keynote_speeches = response.data['en'].keynote_speeches.map(item => item.id);
        this.formData['en'].experts = response.data['en'].experts.map(expert => expert.id);
        let data = {
          forum_id: this.formData['en'].forum_id
        }
        this.axios.post("sessions/builder", data).then((response) => {
          this.builderData.speakersList = response.data.speakers;
        }).catch((error) => {
          console.error(error);
        })
        this.vueDate();
        this.stepKey++;
        this.loader.hide();
      }).catch((error) => {
        console.log(error);
        if (error.response) {
          if (error.response.status === 404) {
            this.entityNotFoundError = true;
            this.$notify({
              message: "Session Not Found",
              timeout: 2000,
              type: 'danger'
            });
          } else {
            console.error(error.response);
          }
        } else {
          console.error("Network error or no response:", error);
        }
        this.loader.hide();
      })
    },
    submit() {
      let request;
      let successMessage;
      this.submitting = true;
      this.laravelDate();
      if (this.editMode === true) {
        request = this.axios.put("sessions/update/" + this.id, this.formData);
        successMessage = "Session Updated Successfully";
      } else {
        request = this.axios.post("sessions/create", this.formData);
        successMessage = "Session Added Successfully";
      }

      request.then((response) => {
        this.$notify({
          message: successMessage,
          timeout: 1000,
          type: 'success'
        })
        this.$router.push("/sessions/list");
      }).catch((error) => {
        if (error.response && error.response.status === 422) {
          this.$refs.formValidator.setErrors(error.response.data.errors);
          this.$refs.itemWizard.navigateToTab(0);
        } else {
          console.error(error.response ? error.response : error);
        }
      }).finally(() => {
        this.submitting = false;
      })
    },
    validateStep(ref) {
      if (Array.isArray(this.$refs[ref])){
        return this.$refs[ref][0].validate();
      }else{
        return this.$refs[ref].validate();
      }
    },
    onStepValidated(validated, model) {
      this.wizardModel = {...this.wizardModel, ...model}
    },
    submitStep(data, lang, isSubmit){
      this.formData[lang] = data;
      if (isSubmit){
        this.submit();
      }
    },
    setNullFormData(){
      this.defaultFormData['en'] = {
        title: "",
        date: "",
        from_time: "",
        to_time: "",
        content: "",
        image: "",
        is_active: true,
        speakers: [],
        forum_id: '',
        moderators: [],
        panelists:[],
        presenters:[],
        presentersModerators:[],
        ceremony_masters:[],
        sharing_experiences:[],
        experts:[],
      };
      this.languageList.forEach(lang => {
        this.defaultFormData[lang] = {
          title: "",
          date: "",
          from_time: "",
          to_time: "",
          content: "",
          image: "",
          is_active: true,
          speakers: [],
          forum_id: '',
        }
      })
    },
    vueDate() {
      this.formData['en'].date = (this.formData['en'].date) ? this.formData['en'].date.replace(' ', 'T') : this.formData['en'].date;
    },
    laravelDate() {
      this.formData['en'].date = (this.formData['en'].date) ? this.formData['en'].date.replace('T', ' ') : this.formData['en'].date;
    },
  }
}
</script>
